import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSidebarFloating"><Path fillRule="evenodd" clipRule="evenodd" d="M19.5 4C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5C2 5.11929 3.11929 4 4.5 4H19.5ZM15.5 11C15.2239 11 15 11.2239 15 11.5V16.5C15 16.7761 15.2239 17 15.5 17H18.5C18.7761 17 19 16.7761 19 16.5V11.5C19 11.2239 18.7761 11 18.5 11H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
